module.exports = __webpack_public_path__ + "static/media/206-Telefonat_ID_15.a8370177.mp3";